import '@radix-ui/themes/styles.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import App from './App';
import './index.scss';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';
import { FullPageLoader } from './components/common/FullPageLoader';
import { ThemeProvider } from './pages/Manager/ThemeProvider';
import { IES } from './utils/labels';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const favicon = document.querySelector("link[rel='icon']");
if (favicon) {
  favicon.setAttribute("href", `${IES.FAVICON}`);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // As listagens incluem a página na chave da query. Sem isto, mudar de
      // página deixa a query sem dados em cache, o status vai a 'loading', o
      // Lists troca a tabela pelo skeleton e a tabela é remontada a cada
      // navegação. Mantendo os dados anteriores, o status fica em 'success' e
      // só o indicador de isFetching se mexe.
      keepPreviousData: true,
    },
  },
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                borderRadius: 'var(--radius-3)',
                background: 'var(--color-panel)',
                color: 'var(--gray-12)',
                border: '1px solid var(--gray-4)',
              },
            }}
          />
          <FullPageLoader />
          <App />
        </ThemeProvider>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
